module.exports = __webpack_public_path__ + "img/authorization-book.e62fd2db.svg";